// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3G9Vg","col":"styles_col__2MEht"};